/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SingleHighestConsumedPartOutput } from '../../models/single-highest-consumed-part-output';

export interface GetHighestConsumedPart$Params {

/**
 * Equipment serial number
 */
  serialNumber: string;

/**
 * Equipment material number
 */
  materialNumber: number;
}

export function getHighestConsumedPart(http: HttpClient, rootUrl: string, params: GetHighestConsumedPart$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleHighestConsumedPartOutput>> {
  const rb = new RequestBuilder(rootUrl, getHighestConsumedPart.PATH, 'get');
  if (params) {
    rb.path('serialNumber', params.serialNumber, {});
    rb.path('materialNumber', params.materialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SingleHighestConsumedPartOutput>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getHighestConsumedPart.PATH = '/api/SpareParts/HighestConsumedPart/{serialNumber}/{materialNumber}';
getHighestConsumedPart.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getHighestConsumedPart.ROOTURL = '/spareparts';
